import { getElement, ifSelectorExist } from './utils'; 

export const sweepstakesFormValidation = () => {
    const sweepstakesForm = document.querySelector('.sweepstakes-form .wpcf7');
    const numberFieldError = document.querySelector('.sweepstakes-form .date-requirement.error');

    if (ifSelectorExist(sweepstakesForm && numberFieldError)) {
        const numberField = document.querySelector('.sweepstakes-form .wpcf7-date');

        if (ifSelectorExist(numberField)) {
            numberField.addEventListener('input', (e) => {
                const numberFieldValue = e.target.value;
    
                const currentDate = new Date();
                const userBirthdate = new Date(numberFieldValue);
                const userAge = currentDate.getFullYear() - userBirthdate.getFullYear();
    
                if (ifSelectorExist(userAge)) {
                    if (userAge <= 18) {
                        numberFieldError.classList.add('show-error');
                        const sweepstakesFormSubmitBtn = document.querySelector('.sweepstakes-form button');
                        sweepstakesFormSubmitBtn.setAttribute('disabled', 'disabled');
                    } else {
                        numberFieldError.classList.remove('show-error');
                        const sweepstakesFormSubmitBtn = document.querySelector('.sweepstakes-form button');
                        sweepstakesFormSubmitBtn.removeAttribute('disabled');
                    }
                }
            });
        }
    }
};

export const sweepstakesFormThankYouModal = () => {
    const sweepstakesForm = getElement('.sweepstakes-form .wpcf7');
    const sweepstakesFormModal = getElement('.sweepstakes-form .thank-you-modal');
    
    if (ifSelectorExist(sweepstakesForm)) {
        sweepstakesForm.addEventListener('wpcf7mailsent', function (event) {
            sweepstakesFormModal.classList.add('block');
            document.body.style.overflow = 'hidden';
        }, false );   
    }

    if (ifSelectorExist(sweepstakesFormModal)) {
        sweepstakesFormModal.addEventListener('click', (e) => {
            if (e.target === sweepstakesFormModal) {
                sweepstakesFormModal.classList.remove('block');
                document.body.style.overflow = null;
            }
        })
    }
}